export default {
  title: {
    frontpage: 'PROJECT TITLE',
    massEditDistrPlan: 'Masserediger distr. plan på {nr} rader'
  },
  auth: {
    login: {
      error: 'En feil oppstod under innlogging',
      btn: 'Logg inn som administrator'
    },
    logOut: {
      btn: 'Logg ut'
    },
    register: {
      title: 'Registrer administrator',
      activationWithContactMail:
        'Ny bruker må aktiveres av en systemansvarlig, kontakt vigo@ist.com',
      activationWithoutContactMail: 'Ny bruker må aktiveres av en systemansvarlig, kontakt'
    },
    created: 'Brukeren {name} har blitt laget!',
    adminUserCreated: 'Administratorbruker opprettet',
    yourUsername: 'Ditt brukernavn',
    password: {
      label: 'Passord',
      confirmLabel: 'Bekreft passord',
      rules: {
        required: 'Passord må være utfylt'
      }
    },
    email: {
      label: 'Email'
    },
    username: {
      label: 'Brukernavn',
      rules: {
        required: 'Brukernavn må være utfylt',
        lessThan: 'Brukernavn må være mindre enn 33 bokstaver'
      }
    },
    displayname: {
      label: 'Visningsnavn'
    }
  },
  button: {
    close: 'Lukk',
    save: 'Lagre',
    filter: 'Filtrer',
    create: 'Opprett',
    update: 'Oppdater',
    back: 'Tilbake',
    next: 'Neste',
    continue: 'Fortsett',
    cancel: 'Avbryt',
    goToStarpage: 'Gå til startsiden'
  },
  kodeverkTable: {
    type: {
      table: 'Tabell',
      table_no_xml: 'Tabell, ikke med i XML-utsendingene',
      logs: 'Logger',
      other: 'Annet'
    },
    publishDate: 'Publiserings dato',
    title: {
      reasonCodes: 'Årsakskoder',
      examForms: 'Eksamensformer',
      examAssessments: 'Eksamen-vurderinger',
      courses: 'Fag',
      courseTypes: 'Fagtyper',
      courseRemarks: 'Fagmerknader',
      foreignLanguages: 'Fremmedspråk',
      mainAreas: 'Hovedområder',
      grades: 'Karakterer',
      competences: 'Kompetansemål',
      competenceSubGoals: 'Kompetansedelmål',
      competenceSets: 'Kompetansemålsett',
      competenceSetCode: 'Kompetansemålsettkode',
      programAreas: 'Programområder',
      programAreaCourses: 'Programområdefag',
      programAreaCategories: 'Programområdekategorier',
      curricula: 'Læreplaner',
      curriculalk20: 'Læreplaner (Lk20)',
      countries: 'Land',
      maalform: 'Målform',
      labels: 'Merkelapper',
      motherTongues: 'Morsmål',
      orders: 'Rekkefølger',
      schools: 'Skoler',
      educationPrograms: 'Utdanningsprogrammer',
      diplomaRemarks: 'Vitnemålsmerknader',
      postalAreas: 'Poststeder',
      municipalities: 'Kommuner',
      counties: 'Fylker',
      variables: 'Div. variabler registreringshåndboken',
      boroughs: 'Bydeler',
      entryRequirements: 'Inntakskrav',
      otStatuses: 'OT-statuser',
      otUnits: 'OT-enheter',
      similarCourses: 'Tilsvarende fag',
      refundRates: 'Refusjons-satser',
      nsrUnits: 'NSR-enheter',
      wishStatuses: 'Statuskoder (på ønske)',
      logs: {
        sync: 'Logg Synkronisering',
        changes: 'Logg Endringer',
        new: 'Nye Fag/Programområder/Utdanningsprogram/Fam/Vmm',
        expired: 'Utgåtte Fag/Programområder/Utdanningsprogram/Fam/Vmm',
        undistributed: {
          courses: 'Fag som ikke er distribuert',
          programAreas: 'Programområder som ikke er distribuert'
        }
      },
      relations: 'Relasjoner',
      roadToCompetenceSubgoal: 'Veien til kompetansedelmål',
      relation: {
        examAssessmentPupil: 'Eksamen vurdering elev',
        examAssessmentPrivate: 'Eksamen vurdering privatist',
        elementReplacesElement: 'Element erstatter element',
        courseUsedTogetherWith: 'Fag benyttes sammen med',
        coursePaabygning: 'Fag påbygning',
        courseBelongsToProgramarea: 'Fag tilhører programområde',
        mainCourseSubCourse: 'Hovedfag delfag',
        mainAreas: 'Hovedområder',
        mainAreaRelatesToCompetenceSet: 'Hovedområde relatert til kompetansemålsett',
        famConnectedToCourse: 'Knytning',
        competenceSetAfterCourses: 'Kompetansemålsett etter fag',
        competenceSetAfterCurriculum: 'Kompetansemålsett etter læreplan',
        competenceSetHasCompetenceGoal: 'Kompetansemålsett har kompetansemål',
        programareaPaabygning: 'Programområde påbygning',
        programareaBelongsToCurriculum: 'Programområde tilhører læreplan',
        programareaBelongsToEducationprogram: 'Programområde tilhører utdanningsprogram',
        belongsToMainarea: 'Tilhører hovedområde',
        usedInYearLevel: 'Benyttes på årstrinn',
        buildsOn: 'Bygger på',
        replacedBy: 'Erstattes av',
        afterYearLevel: 'Etter årstrinn',
        afterCourse: 'Etter fag',
        coursetype: 'Fagtype',
        coursetypeEducationlevel: 'Fagtype opplæringsnivå',
        hasCompetenceGoal: 'Har kompetansemål',
        competenceSetConnectedToCurriculum: 'Kompetansemålsett',
        labelRelatedToCurriculum: 'Merkelapp relatert til læreplan',
        labelRelatedToProgramarea: 'Merkelapp relatert til programområde',
        connectedToGeneralSkill: 'Tilknyttet grunnleggende ferdighet',
        connectedToCoreElement: 'Tilknyttet kjerneelement',
        connectedToInterdisciplinarySubject: 'Tilknyttet tverrfaglig tema',
        connectedToVerb: 'Tilknyttet verb',
        verbBelongsToCurriculum: 'Verb tilhører læreplan'
      }
    }
  },
  validation: {
    asteriskIndicatesRequired: 'Felt med * må fylles ut',
    notEmpty: 'Kan ikke være tom',
    required: 'Må være fylt ut',
    notLonger: 'Kan ikke være lengre enn {max} tegn',
    notShorter: 'Kan ikke være kortere enn {min} tegn',
    notBigger: 'Kan ikke være større enn {max}',
    notSmaller: 'Kan ikke være mindre enn {min}',
    passwordsDontMatch: 'Passordene er ikke like',
    invalidEmail: 'Email er ikke gyldig'
  },
  error: {
    createWithMessage: 'Lagring feilet: {message}',
    updateWithMessage: 'Endring feilet: {message}',
    usernameTaken: 'Brukernavn er allerede i bruk',
    requestMissingValues: 'Mangler verdier',
    inactiveUser: 'Brukeren er ikke aktiv, kontakt vigo@ist.com',
    badCredentials: 'Kunne ikke logge inn, sjekk at brukernavn og passord er riktig.'
  },
  datatable: {
    header: {
      tableActions: '',
      courseRemark: 'Fagmerknad',
      field: 'Felt',
      valueFrom: 'Verdi fra',
      distrPlan: 'Distr. plan',
      actualDistrPlan: 'Distr. plan faktisk',
      validFrom: 'Gyldig f.o.m',
      validTo: 'Gyldig t.o.m',
      forImport: 'Importeres?',
      expired: 'Utgått?',
      lkver: 'LK-versjon',
      active: 'Aktiv?',
      numberOfSubgoals: 'Antall delmål',
      name: {
        normal: 'Navn',
        english: 'Engelsk navn',
        nynorsk: 'Nynorsk navn',
        sami: 'Samisk navn',
        french: 'Fransk navn',
        spanish: 'Spansk navn',
        german: 'Tysk navn',
        formal: 'Formelt navn'
      },
      shortName: {
        normal: 'Kortnavn',
        vigo: 'Kortnavn, VIGO',
        norwegian: 'Kortnavn, Bokmål',
        nynorsk: 'Kortnavn, Nynorsk',
        sami: 'Kortnavn, Samisk',
        english: 'Kortnavn, Engelsk'
      },
      longName: {
        normal: 'Langtnavn',
        vigo: 'Langtnavn, VIGO',
        norwegian: 'Langtnavn, Bokmål',
        nynorsk: 'Langtnavn, Nynorsk',
        sami: 'Langtnavn, Samisk',
        english: 'Langtnavn, Engelsk',
        french: 'Langtnavn, Fransk',
        spanish: 'Langtnavn, Spansk',
        german: 'Langtnavn, Tysk'
      },
      officialName: 'Offisielt navn',
      totalScope: 'Totalt omfang',
      diplomaScope: 'Omfang vitnemål',
      netScope: 'Netto omfang',
      courseType1: 'Fagtype 1',
      courseType2: 'Fagtype 2',
      description: 'Beskrivelse',
      type: 'Type',
      code: 'Kode',
      oldCode: 'Gammel kode',
      newCode: 'Ny kode',
      primarySchool: 'Grunnskole',
      highSchool: 'Videregående',
      vocationalSchool: 'Fagskolen',
      requireAttachment: 'Krav om vedlegg',
      convertTo: 'Konverteres til',
      value: 'Verdi',
      county: {
        nr: 'Fylkesnr.',
        name: 'Fylkesnavn'
      },
      placement: 'Plass',
      psi: 'PSI',
      citizenship: 'Statsborgerskap',
      reform: 'Reform',
      sortNr: 'Sorteringsnr.',
      postNr: 'Postnr.',
      postalArea: 'Poststed',
      municipalityNr: 'Kommunenr.',
      variable: 'Variabel',
      level: 'Nivå',
      firstSemester: 'Første semester',
      lastSemester: 'Siste semester',
      firstExam: 'Første eksamen',
      lastExam: 'Siste eksamen',
      title: 'Tittel',
      verneverdig: 'Verneverdig?',
      examType: 'Eksamenstype',
      programArea: {
        code: 'Programområdekode',
        shortNameWithGradeAndVar: 'Kortnavn m/kat og var',
        longNameWithGradeAndVar: 'Langnavn m/kat og var',
        aktSort: 'Aktsort.',
        normalSort: 'Norm.sort',
        type: 'Type programområde',
        programAreaName: 'Programområdenavn'
      },
      course: {
        name: 'Fagnavn',
        code: 'Fagkode',
        type: 'Fagtype',
        typeCode: 'Fagtypekode'
      },
      educationLevel: {
        title: 'Opplæringsnivå',
        code: 'Opplæringsnivåkode'
      },
      arsak: {
        code: 'Årsakskode'
      },
      examform: {
        type: 'Kode'
      },
      examAssessment: {
        oldCourseCode: 'Gammel fagkode',
        type: {
          examCourse: 'Type eksamensfag',
          courseType: 'Fagtype',
          examform: 'Type eksamensform vitnemål',
          examinationScheme: 'Type eksamensordning',
          assessmentForm: 'Type vurderingsform'
        },
        highestLevel: 'Høyeste nivå',
        pupil: 'Eksamensvurdering elev',
        privateCandidate: 'Eksamensvurdering privatist'
      },
      grade: {
        counts: 'Teller som karakter',
        numberValue: 'Tallverdi'
      },
      competence: {
        grepId: 'Kompetansemål grep-id',
        introduction: 'Kompetansemål - innledning',
        competence: 'Kompetansemål',
        code: 'Kompetansemålkode'
      },
      competenceSet: {
        afterGradeLevel: 'Kompetansemålsett etter årstrinn'
      },
      motherTongue: {
        code: 'Morsmålskode',
        name: 'Morsmål'
      },
      order: {
        grepId1: 'Base grep-id 1',
        grepId2: 'Base grep-id 2'
      },
      grep: {
        validFrom: 'Gyldig fra',
        validTo: 'Gyldig til'
      },
      school: {
        number: 'Skolenummer',
        name: 'Skolenavn',
        type: 'Skoletype',
        owner: 'Skoleeier',
        orgNr: 'Orgnr',
        main: 'Hovedskole',
        previousNumber: 'Tidligere skolenummer',
        newNumber: 'Nytt skolenummer'
      },
      phone: 'Telefon',
      mobile: 'Mobil',
      telefax: 'Telefax',
      email: 'E-post',
      maalform: 'Målform',
      pupilNumber: 'Elevtall',
      org: {
        nr: {
          vof: 'Orgnr. (Vof)'
        }
      },
      protected: 'Beskyttet',
      orgNr: 'Orgnr.',
      unitType: 'Enhetstype',
      defaultCommentDiplomaTY: 'Standardkommentar vitnemål TY',
      vitnemal: 'Vitnemål',
      kompBevis: 'Kompetansebevis',
      lastChanged: 'Sist endret',
      nsr: {
        id: 'NSR-id',
        isSchool: 'Er skole',
        isPrivateSchool: 'Er privatskole',
        isActive: 'Er aktiv',
        characteristics: 'Karakteristikk',
        visit: {
          address: 'Adresse (besøksadresse)',
          postNr: 'Postnr (besøksadresse) Poststedsnavn - se tabellen Poststeder',
          postalArea: 'Poststed (besøksadresse)'
        },
        postAddress: {
          address: 'Adresse (postadresse)',
          postNr: 'Postnr (postadresse) Poststedsnavn - se tabellen Poststeder',
          postalArea: 'Poststed (postadresse)'
        },
        gradeLevelFrom: 'Skoletrinn fra',
        gradeLevelTo: 'Skoletrinn til',
        unitTypes: 'Enhetstyper',
        naceCodes: 'NACE-koder',
        schoolTypes: 'Skoletyper',
        schoolLeader: {
          name: 'Skoleleder',
          email: 'Skoleleders epost',
          phone: 'Skoleleders telefon'
        },
        sectorType: 'Sektortype',
        expired: {
          type: 'Utgått-type'
        },
        created: 'NSR - opprettet',
        updated: 'NSR - oppdatert'
      },
      otStatus: {
        webFilter: 'Webfilter',
        chapter: 'Kapittel(ihht. Udir)'
      },
      address: {
        visit: 'Adresse (besøksadresse)'
      },
      borough: {
        title: 'Bydel',
        nr: 'Bydelsnr.'
      },
      entryRequirement: {
        programAreaName: '- Programområdenavn',
        providesCompetenceName: '- Programområdenavn',
        providesCompetence: 'Gir kompetanse til'
      },
      otUnit: 'OT-enhet',
      postAddress: 'Postadresse',
      street: 'Gate',
      similar: {
        courseCode1: 'Fagkode 1',
        courseShortName1: 'Fagbeskrivelse 1',
        courseLastTaught1: 'Sist undervist 1',
        courseLastExam1: 'Siste eksamen 1',
        courseCode2: 'Fagkode 2',
        courseShortName2: 'Fagbeskrivelse 2',
        courseLastTaught2: 'Sist undervist 2',
        courseLastExam2: 'Siste eksamen 2'
      },
      refund: {
        title: 'Refusjon',
        code: 'Refusjonkode'
      },
      wishStatus: {
        nr: 'Statusnr.',
        code: 'Statuskode',
        type: 'Statustype'
      },
      log: {
        date: 'Logg dato',
        row: {
          type: 'Rad type',
          pk: 'Rad PK'
        }
      },
      coreElement: {
        title: 'Kjerneelement',
        code: 'Kjerneelementkode'
      },
      interdisciplinarySubect: {
        name: 'Tverrfaglig tema',
        code: 'Temakode'
      },
      verb: {
        name: 'Verb'
      },
      tableName: 'Tabellnavn',
      data: 'Data',
      pointCalculation: 'Poeng-beregnes?',
      interdisciplinaryCourse: 'Tverrfaglig eks?',
      commonCourseWithoutSTP: 'Fellesfag uten stp-kar?',
      foreignLanguage: {
        code: 'Fremmedspråk-kode'
      },
      studentHoursAsBasisForCourse: 'Elevtimer som grunnlag for kurs%',
      toImport: 'Importeres?',
      firstTaught: 'Først undervist',
      lastTaught: 'Sist undervist',
      task: 'Oppgave',
      censorship: 'Sensur',
      ibCourse: 'IB-fag',
      defaultComment: 'Standard kommentar',
      remark: 'Merknad',
      aids: 'Hjelpemidler',
      aidsCentralExam: 'Hjelpemidler sentral eksamen',
      courseType: 'Fagtype',
      examCourseType: {
        pupil: 'Type eksamensfag elev',
        privateCandidate: 'Type eksamensfag privatist'
      },
      examFormDiploma: {
        pupil: 'Type eksamensform vitnemål elev',
        privateCandidate: 'Type eksamensform vitnemål privatist'
      },
      examinationScheme: {
        pupil: 'Type eksamensordning elev',
        privateCandidate: 'Type eksamensordning privatist'
      },
      examAssessmentType: {
        pupil: 'Type vurderingsform elev',
        privateCandidate: 'Type vurderingsform privatist'
      },
      endingCourse: {
        normal: 'Standpunkt',
        pupil: 'Standpunkt elev',
        privateCandidate: 'Standpunkt privatist'
      },
      oldCourseCode: 'Gammel fagkode',
      grepId: {
        base: 'Base grep-id'
      },
      mainArea: {
        grepId: 'Hovedområde grep-id',
        title: 'Hovedområder - overskrift',
        introduction: 'Hovedområder - innledning',
        mainArea: 'Hovedområde'
      },
      label: {
        title: 'Merkelapp',
        code: 'Merkelappkode'
      },
      documentReference: 'Dokumentreferanse',
      setDate: 'Fastsatt dato',
      shortForm: 'Kortform',
      determinationText: 'Fastsettelsestekst',
      assessmentSchemeDescription: 'Vurderingsordning beskrivelse',
      assessmentSchemeHeading: 'Vurderingsordning overskrift',
      valuePrinciple: 'Verdiprinsipp',
      subjectRelevance: 'Fagrelevans',
      language: 'Språk',
      structure: 'Struktur',
      numberOfHours: 'Timetall',
      assessmentInCourse: 'Vurdering i faget',
      purposes: 'Formål',
      mainAreasInCourse: 'Hovedområder i faget',
      generalSkill: {
        title: 'Grunnleggende ferdighet',
        code: 'Grunnleggende ferdighet kode',
        written: 'Grunnleggende ferdigheter uttrykk skriftlig ',
        oral: 'Grunnleggende ferdigheter uttrykk muntlig',
        read: 'Grunnleggende ferdigheter lese',
        math: 'Grunnleggende ferdigheter regne',
        digital: 'Grunnleggende ferdigheter digitale verktøy',
        description: 'Grunnleggende ferdigheter beskrivelse',
        text: 'Grunnleggende ferdigheter fritekst'
      },
      typeEducationProgram: 'Type utdanningsprogram',
      educationProgram: {
        code: 'Utdanningsprogramkode'
      },
      category: 'Kategori',
      reimbursementRate: 'Refusjonsats',
      previousDesignation: 'Tidligere betegnelse',
      id: 'Id',
      competenceSetAfterSchoolYear: 'Kompetansemålsett etter årstrinn',
      curriculum: {
        grepId: 'Læreplan grep-id',
        curriculum: 'Læreplan',
        code: 'Læreplankode',
        oldCurriculum: 'Gammel læreplan',
        newCurriculum: 'Ny læreplan'
      },
      nusCode: 'NUS-kode',
      baseCode: 'Grunnkode',
      educationType: 'Utdanningstype',
      hours: {
        ordinary: 'Årstimer ordinært',
        sami: 'Årstimer samisk',
        hearingDisability: 'Årstimer døve og tunghørte',
        shapingCourse: 'Årstimer formgivningsfag',
        statistics: 'Årstimer statistikk'
      },
      yearLevel: {
        title: 'Årstrinn'
      },
      apoCourse: 'APO-kurs',
      endingCompetence: 'Avsluttende komp.?',
      femCourse: 'Inngår i fem-fags-prøven	',
      normedTime: 'Normert tid',
      valueCreationTime: 'Verdiskapningstid',
      letterType: 'Brevtype',
      contractDuration: 'Kontraktsløp',
      alternateCode: 'Alt. kode',
      alfaCode: 'Alfa-kode',
      StudiePoeng: 'Studiepoeng',
      internetAddress: 'Internett-adresse',
      programAreaBelongsToGradelevel: 'Programområde tilhører årstrinn'
    },
    tooltip: {
      compactrows: 'Kompakte rader',
      normalrows: 'Normale rader',
      filter: 'Filtrer data',
      pickcolumns: 'Velg kolonner',
      downloadxlsx: 'Last ned excel-fil',
      seeDetails: 'Se detaljer',
      helpInfo: 'Hjelpeinfo',
      delete: 'Slett',
      edit: 'Rediger',
      create: 'Opprett',
      massEditDistrPlan: 'Masserediger distr. plan'
    },
    title: {
      details: 'Detaljer',
      edit: 'Oppdater',
      create: 'Lag',
      new: 'Ny'
    }
  },
  route: {
    list: 'Tabelliste'
  },
  $vuetify: {
    close: 'Lukk',
    dataIterator: {
      pageText: '{0}-{1} av {2}',
      noResultsText: 'Fant ingen matchende elementer.',
      loadingText: 'Laster elementer...'
    },
    dataTable: {
      itemsPerPageText: 'Rader per side:',
      ariaLabel: {
        sortDescending: ': Sortert synkende. Aktiver for å fjerne sortering.',
        sortAscending: ': Sortert stigende. Aktiver for å sortere synkende.',
        sortNone: ': Ikke sortert. Aktiver for å sortere stigende.',
        activateAscending: 'Sorter stigende',
        activateDescending: 'Sorter synkende'
      },
      sortBy: 'Sorter'
    },
    dataFooter: {
      itemsPerPageText: 'Elementer per side:',
      itemsPerPageAll: 'Alle',
      nextPage: 'Neste side',
      prevPage: 'Forrige side',
      firstPage: 'Første side',
      lastPage: 'Siste side',
      pageText: '{0}-{1} / {2}'
    },
    datePicker: {
      itemsSelected: '{0} valgt',
      nextMonthAriaLabel: 'Neste måned',
      prevMonthAriaLabel: 'Forrige måned'
    },
    noDataText: 'Ingen data er tilgjengelig',
    carousel: {
      prev: 'Forrige bilde',
      next: 'Neste bilde'
    },
    calendar: {
      moreEvents: '{0} mer'
    },
    fileInput: {
      counter: '{0} files',
      counterSize: '{0} files ({1} in total)'
    }
  },
  roadToCompetenceSubgoal: {
    stepper: {
      title: {
        selectEducationProgram: 'Velg utdanningsprogram',
        selectProgramArea: 'Velg programområde',
        selectCurriculum: 'Velg læreplan',
        selectMainArea: 'Velg hovedområde / kompetansemålsett',
        selectCompetence: 'Velg kompetansemål',
        selectCompetenceSubgoal: 'Velg kompetansedelmål'
      }
    },
    deleteSubGoalText: 'Er du sikker på at du vil slette dette delmålet?'
  },
  dataFilter: {
    equal: 'Lik',
    notEqual: 'Ikke lik',
    includes: 'Inneholder',
    doesNotInclude: 'Inneholder ikke',
    startsWith: 'Starter med',
    doesNotStartWith: 'Starter ikke med',
    endsWith: 'Slutter med',
    doesNotEndWith: 'Slutter ikke med',
    greaterThan: 'Større enn',
    lessThan: 'Mindre enn',
    before: 'Før',
    after: 'Etter'
  },
  footer: {
    web_info: {
      host: 'Siden driftes av {link}. Vi bruker cookies.',
      gdpr: 'For mer informasjon, se vår {link}'
    }
  },
  yes: 'Ja',
  no: 'Nei'
}
